import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyOrdersFiltersStatus } from '../../../../../store/supplyOrderSlice'

const SupplyOrdersFilterStatus = () => {

	const status = useSelector(state => state.supplyOrder.supplyOrders.filters.status)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(status)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'newAndWork',
			name: 'Нові та в роботі'
		},
		{
			id: 'new',
			name: 'Нові'
		},
		{
			id: 'work',
			name: 'В роботі'
		},
		{
			id: 'processed',
			name: 'Оброблені'
		},
		{
			id: 'delivered',
			name: 'Доставлені'
		},
		{
			id: 'success',
			name: 'Успішні'
		},
		{
			id: 'cancel',
			name: 'Скасовані'
		},
		{
			id: 'all',
			name: 'Всі'
		},
	])

  return (
    <MySelect
        value={value}
        label="Статус"
        labelId="select__statusFilter-label"
        id='select__statusFilter'
        onChange = {e => {
            setValue(e)
			dispatch(setSupplyOrdersFiltersStatus(e))
			// setEvent({...event, categoryId: e})
		}}
        nameField='Статус'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplyOrdersFilterStatus